import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFavorite = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M22.998 10.95c.466-.432.6-1.098.433-1.698-.2-.6-.7-1.032-1.332-1.132l-5.562-.8a.662.662 0 01-.533-.4l-2.531-4.995a1.618 1.618 0 00-2.931 0L8.044 6.954c-.1.2-.3.366-.533.4l-5.596.799c-.632.1-1.132.533-1.332 1.133-.2.599-.033 1.232.433 1.698l4.03 3.93c.167.167.267.4.2.633l-.966 5.529c-.1.633.134 1.232.666 1.599.5.366 1.166.433 1.732.133l4.963-2.598c.2-.1.466-.1.666 0l4.963 2.598c.233.133.5.2.766.2.333 0 .666-.1.966-.3.5-.366.766-1 .666-1.599l-.966-5.529a.736.736 0 01.2-.633l4.096-3.996z"
  })
});
export default SvgFavorite;